export const FEE = {
  nickname: 'PRODUCTS.FEE.shortname',
  isHidden: true,
  icon:'fee'
};
